<template>
    <div>
        <breadcrumb :routerList="[{to:'/moneyBack_trim',title:'回款管理'},{title:'回款认领调整'}]"/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-pieceIn3">
                    <div class="h-pieceInTitle3">
                        <h1>基本信息</h1>
                    </div>
                    <div class="h-pieceInCon3">
                        <div class="h-formLine h-mrb-38 money">
                            <el-form :inline="true" class="demo-ruleForm h-formbLine">
                                <el-form-item label="销售组织" prop="saleGroupCode" class="h-elformWrap-2 ">
                                    <brselect category="xiaoshou_zuzhi" :v="this.result.saleGroupCode" :showcode="true"
                                              v-model="this.result.saleGroupCode" disabled></brselect>
                                </el-form-item>
                                <el-form-item label="币种" class="h-elformWrap-2">
                                    <mdmselect category="YLCurrency" :v="this.result.receCurrency"
                                               v-model="this.result.receCurrency" disabled/>
                                </el-form-item>
                                <el-form-item label="凭证编码" class="h-elformWrap-2">
                                    <el-input :value="this.result.receCertNumber" readonly></el-input>
                                </el-form-item>
<!--                                <el-form-item label="汇款人" class="h-elformWrap-2">-->
<!--                                    <el-input :value="this.result.remitterName" readonly></el-input>-->
<!--                                </el-form-item>-->
<!--                                <el-form-item label="汇款银行" class="h-elformWrap-2">-->
<!--                                    <el-input :value="this.result.receBank" readonly></el-input>-->
<!--                                </el-form-item>-->
                                <el-form-item label="银行入账金额" class="h-elformWrap-2">
                                    <el-input :value="this.result.receAmount" readonly></el-input>
                                </el-form-item>
<!--                                <el-form-item label="银行会计科目" class="h-elformWrap-2">-->
<!--                                    <el-input :value="this.result.receBankNo" readonly></el-input>-->
<!--                                </el-form-item>-->
                            </el-form>
                        </div>
                    </div>
                </div>

                <div class="h-pieceIn3">
                    <div class="h-pieceInTitle3">
                        <h1>认领信息</h1>
                    </div>
                    <div class="h-pieceInCon3">
                        <div class="h-formLine h-mrb-38 money">
                            <el-form :model="q" :inline="true" class="demo-ruleForm h-formbLine" :rules="rules" ref="q">
                                <el-form-item label="经销商编码" class="h-elformWrap-2">
                                    <el-input :value="q.customerCode" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="经销商名称" class="h-elformWrap-2">
                                    <el-input :value="q.customerName" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="认领金额" class="h-elformWrap-2">
                                    <el-input :value="q.enterAmount" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="手续费" class="h-elformWrap-2">
                                    <el-input :value="q.commission" readonly></el-input>
                                </el-form-item>

                                <el-form-item label="认领余额" class="h-elformWrap-2">
                                    <el-input :value="this.result.balanceAmount" readonly></el-input>
                                </el-form-item>
                        </el-form>
                        </div>
                    </div>
                </div>
                <div class="h-pieceIn3">
                    <div class="h-pieceInTitle3">
                        <h1>关联订单列表</h1>
                    </div>
                    <div class="h-table h-mrt20">
                        <!--                        <el-form label-position="right" status-icon :rules="rules" :model="orders" ref="orders">-->
                        <el-table
                                ref="multipleTable"
                                :data="orders"
                                stripe
                                style="width: 100%"
                                @selection-change="selectOrder"
                        >
                            <el-table-column
                                    type="selection"
                                    width="55"
                                    label="全选"
                                    :selectable='selectInit'
                            >
                            </el-table-column>
                            <el-table-column
                                    fixed
                                    type="index"
                                    label="#"
                                    width="40">
                            </el-table-column>
                            <el-table-column
                                    prop="sapCode"
                                    label="订单编号"
                                    width="120">
                                <template slot-scope="scope">
                                    <el-link type="primary" @click="getOrderInfo(scope.row)">{{scope.row.sapCode}}</el-link>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="add2"
                                    label="SAP订单编号"
                                    width="120">
                            </el-table-column>
                            <el-table-column
                                    prop="cdate"
                                    label="下单时间"
                                    width="140">
                            </el-table-column>
                            <el-table-column
                                    prop="add5"
                                    label="开票时间"
                                    width="140">
                            </el-table-column>
                            <el-table-column
                                    prop="orderPrice"
                                    label="订单总额(元)"
                                    width="120">
                            </el-table-column>
                            <el-table-column
                                    prop="currencyCode"
                                    label="币种"
                                    width="80">
                            </el-table-column>
<!--                            <el-table-column-->
<!--                                    prop="exchange"-->
<!--                                    label="RMB汇率"-->
<!--                                    width="100">-->
<!--                            </el-table-column>-->
                            <el-table-column
                                    prop="claimMoney"
                                    label="认领金额(元)"
                            >
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.flag">{{scope.row.claimMoney}}</span>
                                    <!--                                        <el-form-item :prop="'orders' + [scope.$index] + '.claimMoney'"-->
                                    <!--                                                      :rules="rules.claimMoney">-->
                                    <el-input v-if="scope.row.flag" v-model="scope.row.claimMoney"  type="number"
                                               @change="changeClaimMoney(scope.row)"></el-input>
                                    <!--                                        </el-form-item>-->
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="orderPriceDhk"
                                    label="剩余未回款金额(元)"
                            >
                            </el-table-column>
                        </el-table>
                        <!--                        </el-form>-->
                        <div class="h-tableBInfo">
                            <div class="h-tableBInfowrap">
                                <span>认领总额</span>
                                <span>{{this.q.enterAmount}}元</span>
                            </div>
                            <div class="h-tableBInfowrap">
                                <span>认领余额</span>
                                <span :class="{changecolor:change===true}">{{this.restMoney}}元</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="quxiao">返回</el-button>

                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="trim"
                           >提交
                </el-button>

            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="80%" class="body_dilog">
            <el-table
                    ref="multipleTable"
                    :data="orderProcess"
                    stripe
                    style="width: 100%"

            >
                <el-table-column
                        type="index"
                        label="#"
                        fixed
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="sapCode"
                        label="订单号"
                        fixed
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>

                <el-table-column
                        prop="soldToName"
                        label="经销商"
                        fixed
                        :show-overflow-tooltip="true"
                        width="160">
                    <template slot-scope="scope">
                        <div style="text-align: left;" :title="scope.row.soldToName">
                            {{scope.row.soldToName}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="materialName"
                        label="商品名称"
                        fixed
                        :show-overflow-tooltip="true"
                        width="180">
                    <template slot-scope="scope">
                        <div style="text-align: left;" :title="scope.row.materialName">
                            {{scope.row.materialName}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="proNumber"
                        label="数量"
                        width="60">
                    <template slot-scope="scope">
                        <div style="text-align: right;" :title="scope.row.proNumber">
                            {{scope.row.proNumber}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="note"
                        label="备注"
                        :show-overflow-tooltip="true"
                        min-width="180">
                    <template slot-scope="scope">
                        <div style="text-align: left;" :title="scope.row.note">
                            {{scope.row.note}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="prodtype"
                        label="自产/OEM"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="materialCode"
                        label="商品编码"
                        width="110">
                    <template slot-scope="scope">
                        <div :title="scope.row.materialCode">
                            {{scope.row.materialCode}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="订单状态"
                        width="100">
                    <template scope="scope">
                        {{scope.row.status|dictname('order_status')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="orderCategory"
                        label="订单类型"
                        :show-overflow-tooltip="true"
                        width="150">
                    <template scope="scope">
                        {{scope.row.orderCategory|dictname('xiaoshou_quyu') }}
                        {{scope.row.orderCategory1|dictname('xiaoshou_quyu_nwx') }}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="saleGroupCode"
                        label="销售组织"
                        :show-overflow-tooltip="true"
                        width="260">
                    <template scope="scope">
                        <div style="text-align: left;">
                            [{{scope.row.saleGroupCode}}]{{scope.row.saleGroupCode|dictname('YLSalesOrganization_agent')}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="add3"
                        label="DN单号"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="waybillId"
                        label="物流单号"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="add2"
                        label="SO单号"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>

                <el-table-column
                        prop="add1"
                        label="信用检查状态"
                        :show-overflow-tooltip="true"
                        width="120">
                    <template scope="scope">
                        {{scope.row.add1|dictname('xinyong_zhuangtai')}}
                    </template>
                </el-table-column>

                <el-table-column
                        prop="iszhidan"
                        label="经销商类型"
                        :show-overflow-tooltip="true"
                        width="110">
                    <template scope="scope">
                        {{scope.row.iszhidan|dictname('dailishang_leixing')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="soldToCode"
                        label="经销商编码"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="proModelName"
                        label="商品大类"
                        :show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="tejiashuoming"
                        label="特价描述"
                        :show-overflow-tooltip="true"
                        width="180">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            {{scope.row.tejiashuoming}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="sid"
                        label="特价版本号"
                        :show-overflow-tooltip="true"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="orderProjectCode"
                        label="工程版本号"
                        :show-overflow-tooltip="true"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="finalPrice"
                        label="单价"
                        :show-overflow-tooltip="true"
                        width="70">
                    <template slot-scope="scope">
                        <div style="text-align: right;">
                            {{scope.row.finalPrice}}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="totalprice"
                        label="总价"
                        :show-overflow-tooltip="true"
                        width="70">
                    <template slot-scope="scope">
                        <div style="text-align: right;">
                            {{scope.row.totalprice}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="orderNetWorth"
                        label="净收入/净价值"
                        :show-overflow-tooltip="true"
                        width="130">
                    <template slot-scope="scope">
                        <div style="text-align: right;">
                            {{scope.row.orderNetWorth}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="currencyCode"
                        label="币种"
                        :show-overflow-tooltip="true"
                        width="70">
                    <template slot-scope="scope">
                        <div style="text-align: right;">
                            {{scope.row.currencyCode}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="shouyiarea"
                        label="收益区域"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template scope="scope">
                        {{scope.row.shouyiarea|dictname('YLRegion')}}
                    </template>
                </el-table-column>

                <el-table-column
                        prop="shifouyidi"
                        label="是否异地"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template scope="scope">
                        {{scope.row.shifouyidi|dictname('shifou_keyong')}}
                    </template>
                </el-table-column>

                <el-table-column
                        prop="soldToAreaName"
                        label="售达方区域"
                        :show-overflow-tooltip="true"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="customerChannelCode"
                        label="销售渠道"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template scope="scope">
                        {{scope.row.customerChannelCode|dictname('sales_region')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="toCompanyname"
                        label="收货单位"
                        :show-overflow-tooltip="true"
                        width="180">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            {{scope.row.toCompanyname}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="contactName"
                        label="联系人"
                        :show-overflow-tooltip="true"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="firsttelephone"
                        label="电话"
                        :show-overflow-tooltip="true"
                        width="120">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            {{scope.row.firsttelephone}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="soldToAreaName"
                        label="地区"
                        :show-overflow-tooltip="true"
                        width="80">
                </el-table-column>

                <el-table-column
                        prop="soldToName"
                        label="省市名称"
                        :show-overflow-tooltip="true"
                        width="110">
                    <template scope="scope">
                        {{ `${scope.row.toProvincesName || ''}${scope.row.toCityName || ''}`}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="toAddress"
                        label="详细地址"
                        :show-overflow-tooltip="true"
                        width="180">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            {{scope.row.toAddress}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="isStockUp"
                        label="是否备货"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template scope="scope">
                        {{scope.row.isStockUp|dictname('shifou_keyong')}}
                    </template>
                </el-table-column>

                <el-table-column
                        prop="cdate"
                        label="创建时间"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="receivedTime"
                        label="预期收货时间"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <!--                <el-table-column-->
                <!--                        prop="sptgTime"-->
                <!--                        label="审核通过时间"-->
                <!--						:show-overflow-tooltip="true"-->
                <!--                        width="220">-->
                <!--                </el-table-column>-->
                <el-table-column
                        prop="sptgTime"
                        label="销售订单生成日期"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="fhdate"
                        label="安排发货时间"
                        :show-overflow-tooltip="true"
                        :key="Math.random()"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="delTime"
                        label="生成发货计划时间"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="wlyjfh"
                        label="计划发货日期"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="wlyjdh"
                        label="计划到货日期"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="delTime"
                        label="实际发货日期"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="arrTime"
                        label="实际到货日期"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="nxEightTime"
                        label="客户签收日期"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="taxCode"
                        label="税分类编码"
                        :show-overflow-tooltip="true"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="bktxt"
                        label="纸质发票号"
                        :show-overflow-tooltip="true"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="arStatus"
                        label="是否清账"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template scope="scope">
                        {{scope.row.arStatus|dictname('pgiStatus')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="billingStatus"
                        label="发票是否创建"
                        :show-overflow-tooltip="true"
                        width="120">
                    <template scope="scope">
                        {{scope.row.billingStatus|dictname('pgiStatus')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="disChannelCode"
                        label="分销渠道"
                        :show-overflow-tooltip="true"
                        width="110">
                    <template scope="scope">
                        {{scope.row.disChannelCode|dictname('fenxiao_qudao')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="add4"
                        label="系统发票号"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="add5"
                        label="开票时间"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="ldate"
                        label="最后更新时间"
                        width="160"
                        :show-overflow-tooltip="true">
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>


</template>

<script>
    import ss from '../../../api/SystemService'

    export default {
        name: 'leftMenu',
        data() {
            return {
                huilv: '',
                currency: '',
                backurl:'',
                dialogFormVisible:false,
                rules: {
                    customerCode:[
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    customerName1: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    enterAmount: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    commission: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    countryCode: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    tradeWay: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    claimMoney: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    claimCurrency:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                },
                isBandOrders: false,
                usercode: '',
                ordersRegional: [],
                refid: '',
                reftype: '回款认领-第三方回款委托证明',
                restMoney: null,
                res: {
                    receMark: null
                },
                balanceAmountFlg : false,
                claimParams: {
                    orderNoList: [],
                    userReceForeign: {
                        id: null,
                        remitterName: null,
                        receAmount: null,
                        receMark: null,
                        receCertNumber: null,
                        receBank: null,
                        receDate: null,
                        remitterCode: null,
                        areaCode: null,
                        commission: 0,
                        claimName: null,
                        claimCode: null,
                        claimPhone: null,
                        countryCode: null,
                        tradeWay: null,
                        enterAmount: null,
                    }
                },
                value: {},
                orders: [],
                orderProcess :[],
                q:
                    {
                        orderNoList:
                            null,
                        commission: 0,
                        claimPhone: null,
                        countryCode: null,
                        tradeWay: '1',
                        enterAmount: null,
                    }
                ,
                user: {}
                ,
                userOne: {
                    accountGroup: null,
                    appellation:
                        null,
                    cdate:
                        null,
                    cityStreetRoom:
                        null,
                    companyAddress:
                        null,
                    companyCode:
                        null,
                    contactCity:
                        null,
                    contactMobilePhone:
                        null,
                    country:
                        null,
                    cucode:
                        null,
                    cuname:
                        null,
                    customerName1:
                        null,
                    customerNumber:
                        null,
                    customerTitle:
                        null,
                    delflag:
                        null,
                    faxNumber:
                        null,
                    language:
                        null,
                    ldate:
                        null,
                    lucode:
                        null,
                    name1:
                        null,
                    partnerFlagBp:
                        null,
                    partnerFlagPy:
                        null,
                    partnerFlagSh:
                        null,
                    partnerFlagSp:
                        null,
                    phoneNumber:
                        null,
                    phoneNumber1:
                        null,
                    postalCode:
                        null,
                    region:
                        null,
                    searchTerm:
                        null,
                    streetRoom:
                        null,
                    taxCode:
                        null,
                    usercode:
                        null
                }
                ,
                result: {}
                ,
                //表单
                formInline: {
                    customerName: '',
                    date1:
                        '',
                    date2:
                        '',
                    date3:
                        '',
                    type:
                        ''
                },
                //表格
                multipleSelection: [],
                tableData2: [],
                //上传凭证
                fileList: [],
                doNotClaim: false,
                change: false,
                bscUserInfoAgentBasic: {
                    region: null,
                }
            }
        },
        created() {
            this.queryUser();
            if (this.$route.query.id == undefined) {
                this.refid = this.$route.query.ywid;
            } else {
                this.refid = this.$route.query.id;
            }
            this.backurl = "/"+this.$route.query.backurl;
            // debugger
        },
        methods: {
            changeClaimMoney(v) {
                if ( parseFloat(v.claimMoney) <0 ) {
                    this.$confirm('认领金额应小于等于待回款金额！', '提示', {
                        confirmButtonText: '确认',
                        type: 'warning'
                    }).then(() => {
                        for (var i = 0; i < this.orders.length; i++) {
                            if (this.orders[i].id == v.id) {
                                this.orders[i].claimMoney = null;
                            }
                        }
                        this.doNotClaim = false;
                    }).catch(() => {
                        this.doNotClaim = true;
                    })
                } else {

                    this.doNotClaim = false;
                    var useMoney = 0;
                    var zy = 0;
                    for (var i = 0; i < this.orders.length; i++) {
                        if (this.orders[i].id == v.id) {

                            if(undefined  != this.ordersRegional[i].claimMoney){
                                zy = JSON.parse(JSON.stringify(this.ordersRegional[i].claimMoney));
                            }
                            if (parseFloat(JSON.parse(JSON.stringify(this.ordersRegional[i].orderPriceDhk)) + parseFloat(zy) - v.claimMoney) < 0 ) {
                                this.$confirm('认领金额应小于等于待回款金额！', '提示', {
                                    confirmButtonText: '确认',
                                    type: 'warning'
                                }).then(() => {

                                    this.doNotClaim = false;
                                    return ;
                                }).catch(() => {

                                    this.doNotClaim = true;
                                    return ;
                                })
                            }
                            this.orders[i].orderPriceDhk = parseFloat(JSON.parse(JSON.stringify(this.ordersRegional[i].orderPriceDhk)) + parseFloat(zy) - v.claimMoney).toFixed(2);
                        }
                        if (this.orders[i].claimMoney != undefined && this.orders[i].claimMoney != '') {
                            useMoney += parseFloat(this.orders[i].claimMoney);
                        }
                    }
                    if((parseFloat(this.q.enterAmount) - useMoney).toFixed(2) < 0){
                        this.$confirm('认领金额应小于等于待回款金额！', '提示', {
                            confirmButtonText: '确认',
                            type: 'warning'
                        }).then(() => {

                            this.doNotClaim = false;
                        }).catch(() => {
                            this.doNotClaim = true;
                        })
                    }else{
                        this.restMoney = (parseFloat(this.q.enterAmount) - useMoney).toFixed(2);
                    }
                }
            },

            queryForeign(v) {
                ss.moneyBackforeignService.queryForeign(v).then(response => {
                    // console.log(response, 'gggggggggggg')
                    // this.result = response.obj;
                    // if (response.obj.isBandOrders == 1) {
                    //     this.isBandOrders = true;
                    //     this.q.enterAmount = response.obj.enterAmount;
                    // }

                    this.result = response.obj;
                    this.usercode = response.obj.customerCode;
                    this.q.receCurrency = response.obj.receCurrency;
                    this.q.saleGroupCode = response.obj.saleGroupCode;
                    // this.q = response.obj;
                    if (response.obj.isBandOrders == 1) {
                        this.isBandOrders = true;
                        this.q.enterAmount = response.obj.enterAmount;
                    }
                    //this.isBandOrders = true;
                    // debugger
                    // ss.moneyBackClaimService.orders(response.obj.customerCode, response.obj.receCurrency,response.obj.saleGroupCode).then(rd => {
                    //     this.orders = rd;
                    //     this.ordersRegional = JSON.parse(JSON.stringify(rd));
                    //     console.log(this.orders)
                    // })
                    // this.q.enterAmount = response.obj.enterAmount;
                    // this.countCommission();
                })
            },
            countCommission() {

                // ss.OrderMainService.getExchange({
                //     fromCurrency: this.result.receCurrency,
                //     toCurrency: this.result.claimCurrency==null?this.result.receCurrency:this.result.claimCurrency
                // }).then(rd => {
                //     console.log(rd, '汇率')
                //     this.huilv = rd;
                //     this.q.commission =this.q.enterAmount - parseFloat(this.result.balanceAmount) * parseFloat(this.huilv).toFixed(2);
                //     // this.restMoney = parseFloat(this.q.enterAmount) * parseFloat(this.huilv).toFixed(2);
                //     this.restMoney = this.q.enterAmount
                // })
                // console.log(this.restMoney, '余额')
                this.q.commission =parseFloat(this.q.enterAmount - parseFloat(this.result.receAmount)).toFixed(2);
                // this.restMoney = parseFloat(this.q.enterAmount) * parseFloat(this.huilv).toFixed(2);
                // debugger
                this.restMoney = this.q.balanceAmount ==undefined || this.q.balanceAmount == null ? this.q.enterAmount:this.q.balanceAmount;
                if(this.q.balanceAmount ==undefined){
                    this.balanceAmountFlg = true
                }
                if(this.balanceAmountFlg){
                    this.q.balanceAmount = this.q.enterAmount;
                }

            },
            countCommissionYufu() {
                ss.OrderMainService.getExchange({
                    fromCurrency: this.result.receCurrency,
                    toCurrency: this.result.claimCurrency==null?this.result.receCurrency:this.result.claimCurrency
                }).then(rd => {
                    console.log(rd, '汇率')
                    this.huilv = rd;
                    this.q.commission =this.q.enterAmount - parseFloat(this.result.balanceAmount) * parseFloat(this.huilv).toFixed(2);

                    this.restMoney = parseFloat(this.q.enterAmount) * parseFloat(this.huilv).toFixed(2);
                })
                console.log(this.restMoney, '余额')
            },
            queryUser() {
                console.log(this._user, "当前登录人")
                this.bscUserInfoAgentBasic.region = this._user.area;
                ss.moneyBackClaimService.query(this.bscUserInfoAgentBasic).then(rd => {
                    console.log(rd);
                    this.user = rd;
                })
            },
            queryUserCode(v) {
                for (var i = 0; i < this.user.length; i++) {
                    if (this.user[i].usercode == v) {
                        //this.q.soldToCode = this.user[i].usercode;
                        this.q.customerName = this.user[i].customerName1;
                        this.q.claimPhone = this.user[i].phoneNumber;
                        this.usercode = this.user[i].usercode;
                    }
                }
                //查询客户对应的订单
                this.currency = this.q.receCurrency;
                this.saleGroupCode = this.q.saleGroupCode;
                debugger
                ss.moneyBackClaimService.orders(this.usercode,this.currency,this.saleGroupCode).then(rd => {
                    this.orders = rd;
                    this.ordersRegional = JSON.parse(JSON.stringify(rd));
                    console.log(this.orders)
                })
                this.countCommission();
            },

            selectOrder(v) {
                console.log(v, '单条订单信息')
                console.log(this.orders, 'this.orders')
                //被选中的订单可以编辑回款金额
                for (var i = 0; i < v.length; i++) {
                    v[i].flag = true;
                }
                //未被选中的订单不可修改回款金额
                for (var j = 0; j < this.orders.length; j++) {
                    var count = 0;
                    for (var a = 0; a < v.length; a++) {
                        if (this.orders[j].id != v[a].id) {
                            count += 1;
                        }
                    }
                    //没被选择的订单可以进行的操作
                    if (count == v.length) {
                        this.orders[j].flag = false;
                        if(undefined != this.ordersRegional[j].claimMoney){
                            this.orders[j].claimMoney = JSON.parse(JSON.stringify(this.ordersRegional[j].claimMoney));
                        }else{
                            this.$delete(this.orders[j],'claimMoney');
                        }

                        this.orders[j].orderPriceDhk = JSON.parse(JSON.stringify(this.ordersRegional[j].orderPriceDhk));
                    }
                }
                var zy = 0;
                //刷新待回款金额
                for (var b = 0; b < v.length; b++) {
                    for (var c = 0; c < this.ordersRegional.length; c++) {
                        if (v[b].id == this.ordersRegional[c].id) {
                            if (v[b].claimMoney == undefined) {
                                v[b].orderPriceDhk = JSON.parse(JSON.stringify(this.ordersRegional[c].orderPriceDhk));
                            } else {


                                if(undefined != this.ordersRegional[c].claimMoney){
                                    zy = JSON.parse(JSON.stringify(this.ordersRegional[c].claimMoney));
                                }
                                v[b].orderPriceDhk = JSON.parse(JSON.stringify(this.ordersRegional[c].orderPriceDhk)) + zy  - v[b].claimMoney;
                            }

                        }
                    }
                }
                //刷新认领余额
                var useMoney = 0;
                for (var d = 0; d < this.orders.length; d++) {
                    if (this.orders[d].claimMoney != undefined) {
                        useMoney += parseFloat(this.orders[d].claimMoney);
                    }
                }

                this.restMoney = parseFloat(this.q.enterAmount)  - useMoney;
                this.value = v;
            },
            reSelectOrder() {
                this.orders = JSON.parse(JSON.stringify(this.ordersRegional));
            },
            selectInit(row, index) {
                if (row.sapCode == ''|| row.sapCode == null || row.add2 == '' || row.add2 == null) {
                    return false;
                } else {
                    return true;
                }
            },


            trim() {
                if (this.value.length === undefined || this.value.length === 0) {
                        this.$message({
                            type: "error",
                            message: '必须选择订单！'
                        });
                        return;

                } else {

                    console.log(this.value, "value")
                    this.claimParams.orderNoList = [];
                    for (var i = 0; i < this.value.length; i++) {
                        this.claimParams.orderNoList.push(this.value[i]);
                    }
                    this.claimParams.userReceForeign = this.result;

                    console.log(this.claimParams, 'cccccc')
                    ss.moneyBackClaimService.trim(this.claimParams).then(rd => {
                        console.log(rd);
                        if (rd.f) {
                            this.$message({
                                type: "success",
                                message: rd.msg
                            });
                            this.$router.push({path: this.backurl});
                        } else {
                            this.$message({
                                type: "error",
                                message: rd.msg
                            });
                        }
                    })
                }
            },
            quxiao() {
                //this.$router.back();
                this.$router.push({path: this.backurl});
            },
            getOrderInfo(v){
                this.dialogFormVisible = true
                ss.moneyBackClaimService.orderProcessPage({"sapCode":v.sapCode}).then(rd => {
                    console.log(rd);
                    this.orderProcess = rd
                })
            }
        },
        mounted() {
            ss.moneyBackforeignService.queryForeign(this.$route.query.id).then(response => {
                this.result = response.obj;
                this.usercode = response.obj.customerCode;
                this.q = response.obj;
                if (response.obj.isBandOrders == 1) {
                    this.isBandOrders = true;
                }
                //this.isBandOrders = true;
                this.q.foreignId = this.$route.query.id;

                ss.moneyBackClaimService.selectTrimList(this.q).then(rd => {
                    this.orders = rd;
                    this.ordersRegional = JSON.parse(JSON.stringify(rd));
                    console.log(this.orders)
                })
               // this.q.enterAmount = response.obj.enterAmount;
                this.countCommission();

            })
        }

    }
</script>

<style>
    .money .h-formbLine .el-form-item__label {
        width: 40%;
        text-align: right;
    }

    .money .h-formbLine .el-form-item__content {
        width: 60%;
    }

    .money .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }

    .money .h-formbLine .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .money .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 11%;
    }

    .money .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 89%;
    }
</style>
